export default __webpack_public_path__ + "static/media/avatar.dcea9339.svg";